import { Pipe, PipeTransform } from '@angular/core';

import { LanguageEnum } from '../../enums/language.enum';

const LANGUAGE_MAP: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'English',
  [LanguageEnum.ES]: 'Spanish',
};

@Pipe({
  name: 'languageName',
  standalone: true,
})
export class LanguageNamePipe implements PipeTransform {
  transform(value: LanguageEnum | string | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return LANGUAGE_MAP[value as LanguageEnum] || value;
  }
}
